import { GlobalAxios } from "../axios/axios-config";
import { INewTasySchedMenu, ITasySchedMenu } from "../models/tasy-sched-menu";

const TASY_SCHED_MENU_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v1/TasySchedMenu";

export const createTasySchedMenu = (item: INewTasySchedMenu) => {
  return GlobalAxios.post(TASY_SCHED_MENU_ROUTE, item);
};

export const getTasySchedMenuById = (id: string) => {
  return GlobalAxios.get<ITasySchedMenu>(TASY_SCHED_MENU_ROUTE + "/" + id);
};

export const updateTasySchedMenuById = ({
  item,
  id,
}: {
  item: INewTasySchedMenu;
  id: string;
}) => {
  return GlobalAxios.put(TASY_SCHED_MENU_ROUTE + "/" + id, item);
};
